module.exports = __webpack_public_path__ + "static/img/afg_choice_tag.6642fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afg_choice_tag.png
// module id = e6jC
// module chunks = 1